'use client';

import { useState } from 'react';
import type { CreatorExperienceId } from './experience-config';

export const CREATOR_STEPS = ['purpose', 'content', 'design', 'review'] as const;
export type CreatorStep = (typeof CREATOR_STEPS)[number];

export function getNextCreatorStep(step: CreatorStep): CreatorStep | undefined {
	const index = CREATOR_STEPS.indexOf(step);
	return CREATOR_STEPS[index + 1];
}

export function getPreviousCreatorStep(step: CreatorStep): CreatorStep | undefined {
	const index = CREATOR_STEPS.indexOf(step);
	return CREATOR_STEPS[index - 1];
}

export function useCreatorWizard() {
	const [step, setStep] = useState<CreatorStep>('purpose');
	const [experience, setExperience] = useState<CreatorExperienceId | null>('website');

	return {
		step,
		experience,
		canAdvance: step !== 'purpose' || experience !== null,
		selectExperience: (value: CreatorExperienceId) => setExperience(value),
		resumeAtReview: (value: CreatorExperienceId) => {
			setExperience(value);
			setStep('review');
		},
		next: (validate: () => boolean = () => true) => {
			if (!validate()) return false;
			const nextStep = getNextCreatorStep(step);
			if (!nextStep) return false;
			setStep(nextStep);
			return true;
		},
		back: () => {
			const previousStep = getPreviousCreatorStep(step);
			if (previousStep) setStep(previousStep);
		},
		startOver: () => {
			setStep('purpose');
			setExperience(null);
		},
	};
}
